import React from "react";
import styled from "styled-components";
import CaretIconToggle from "@common/Icons/CaretIconToggle";
import { LifeAtButtonV2 } from "@common/LifeAtButtonV2/LifeAtButtonV2";

const Count = styled.span`
    color: ${(props) => props.theme.textColorSpecial};
    font-weight: bold;
`;

interface TaskFilterButtonProps {
    label: string;
    count: number;
    isOpen: boolean;
}

export function TaskFilterButton(props: TaskFilterButtonProps) {
    return (
        <LifeAtButtonV2 variant="secondary">
            {props.label}
            {props.count > 0 && <Count>{props.count}</Count>}
            <CaretIconToggle showOpen={props.isOpen} />
        </LifeAtButtonV2>
    );
}
